export default __webpack_public_path__ + "static/media/celebration-empresa-criada.744413db.png";